<template>
    <div class="container mt-4">
        <div class="row">
            <div class="col-12 col-lg-6 col-xl-4">
                <div class="card">
                    <div class="card-body">
                        <div class="p-1 mb-3">
                            <h6 class="card-title text-uppercase text-muted mb-0">{{ $t('Today') }}</h6>
                            <span class="h4">{{ today.date | moment('dddd MMMM DD, YYYY ') }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-6 col-xl-4">
                <my-appointments/>
            </div>
            <div class="col-12 col-md-6 col-lg-4" v-if="report">
                <report-card :value="report.earnings" label="Total earned" money icon="fe fe-dollar-sign"></report-card>
            </div>
            <div class="col-12 col-md-6 col-lg-4" v-if="report">
                <report-card :value="report.paid" label="Total paid" money icon="fe fe-dollar-sign"></report-card>
            </div>
            <div class="col-12 col-md-6 col-lg-4" v-if="report">
                <report-card :value="report.revenue" label="Your revenue" money icon="fe fe-dollar-sign"></report-card>
            </div>
            <div class="col-12" v-if="false">
                <div class="card">
                    <div class="card-body">
                        <table class="table table-sm table-nowrap my-4" style="width:100%">
                            <thead>
                            <tr>
                                <th scope="col" style="width:65%">{{ $t('Service') }} / {{ $t('Products') }}</th>
                                <th scope="col" class="text-center">{{ $t('Quantity') }}</th>
                                <th scope="col" class="text-right">{{ $t('Cost') }}</th>
                                <th scope="col" class="text-right">{{ $t('Total') }}</th>
                                <th scope="col" class="text-right">{{ $t('Revenue') }}(%)</th>
                            </tr>
                            </thead>
                            <tbody v-for="(service, serviceIndex) in reportDetails" :key="serviceIndex">
                            <tr v-if="service.treatment">
                                <td>
                                    <div>{{ service.treatment.label }}</div>
                                </td>
                                <td class="text-center">{{ service.quantity || 1 }}</td>
                                <td class="text-right">
                                    <money :value="service.cost"></money>
                                </td>
                                <td class="text-right">
                                    <money :value="service.total"></money>
                                </td>
                                <td class="text-right">
                                    <money :value="service.revenue"></money>
                                </td>
                            </tr>
                            <tr v-if="service.product">
                                <td class>
                                    <div>{{ service.product.label }}</div>
                                    <small
                                        class="text-muted"
                                        v-if="service.user"
                                    >{{ service.user.firstName }} {{ service.user.lastName }}</small>
                                </td>
                                <td class="text-center">{{ service.quantity }}</td>
                                <td class="text-right">
                                    <money :value="service.cost"></money>
                                </td>
                                <td class="text-right">
                                    <money :value="service.total"></money>
                                </td>
                                <td class="text-right">
                                    <money :value="service.revenue"></money>
                                </td>
                            </tr>
                            </tbody>
                            <thead></thead>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-12" v-if="false">
<!--                <line-chart :chartData="weeklyEarnings" scheme="HueCircle19"></line-chart>-->
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import Money from '@/components/Money.vue';
import MyAppointments from '@/components/Widgets/MyAppointments'
import LineChart from "@/components/Charts/LineChart";
import ReportCard from "../Pages/Reports/ReportCard";

export default {
    mixins: [],
    components: {
        ReportCard,
        LineChart,
        MyAppointments,
        Money
    },
    data() {
        return {
            today: {
                date: this.$moment()
            },
            lineChartMethod: 'revenue',
            report: {},
            weeklyEarnings: [],
            daysOfWeek: [
                this.$t('Monday'),
                this.$t('Tuesday'),
                this.$t('Wednesday'),
                this.$t('Thursday'),
                this.$t('Friday'),
                this.$t('Saturday'),
                this.$t('Sunday')
            ]
        };
    },
    computed: {
        ...mapState('auth', ['user']),
        ...mapGetters('invoices', { findInvoicesInStore: 'find' })
    },
    created() {
        this.fetchReports();
    },

    methods: {
        ...mapActions('invoices', { findInvoices: 'find' }),
        ...mapActions('sales-reports', ['find']),

        fetchReports() {
            this.fetchSalesReport();
            // this.fetchWeeklyEarnings();
        },

        fetchInvoices() {
            let query = {
                'services.userId': this.user._id,
                createdAt: {
                    $gte: this.$moment().startOf('day'),
                    $lte: this.$moment().endOf('day')
                }
            };
            this.findInvoices({ query }).then(data => console.log(data));
        },

        fetchSalesReport() {
            let query = {
                userId: this.user._id,
                date: {
                    $gte: this.$moment().startOf('day'),
                    $lte: this.$moment().endOf('day')
                }
            };
            this.find({ query }).then(data => {
                this.report = data[0].byUser[0];
                this.fetchInvoices();
            });
        },

        fetchWeeklyEarnings() {
            let query = {
                userId: this.user._id,
                date: {
                    $gte: this.$moment().startOf('week'),
                    $lte: this.$moment().endOf('week')
                }
            };
            this.fetchSales({ query }).then(data => {
                this.weeklyEarnings = [];
                this.daysOfWeek.forEach((item, index) => {
                    const day = data.data.find(el => this.$moment(el.date).weekday() === index) || { revenue: 0 };
                    this.weeklyEarnings.push({ _id: this.daysOfWeek[index], count: day.revenue })
                });
            });
        }
    },
};
</script>
